document.addEventListener('DOMContentLoaded', () => {

  const drawer = document.querySelector('#TwistedDrawer');
  const trigger = document.querySelector('.header__icon--menu');
  const close = document.querySelector('.twisted-drawer__close');

  const tabs = document.querySelectorAll('.twisted-drawer__tab');
  const panels = document.querySelectorAll('.twisted-drawer__menu');


  if (!drawer || !trigger) return;


  // Open / close drawer
  trigger.addEventListener('click', (event) => {

    event.preventDefault();
    event.stopImmediatePropagation();

    const details = trigger.closest('details');

    if (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    }

    drawer.classList.toggle('open');

    drawer.classList.remove('animate');

setTimeout(() => {
  drawer.classList.add('animate');

moveDrawerIndicator();

}, 250);

    drawer.setAttribute(
      'aria-hidden',
      drawer.classList.contains('open') ? 'false' : 'true'
    );

  }, true);


  // Close button
if (close) {

  close.addEventListener('click', () => {
drawer.classList.remove('animate');
    drawer.classList.remove('open');

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

    });

  }


  // Shop / Explore tabs
  tabs.forEach(tab => {

    tab.addEventListener('click', () => {

      tabs.forEach(item => {
        item.classList.remove('active');
      });

      panels.forEach(panel => {
        panel.classList.remove('active');
      });


      tab.classList.add('active');


      const target = drawer.querySelector(
        `[data-panel="${tab.dataset.tab}"]`
      );


     if (target) {
  target.classList.add('active');
}

moveDrawerIndicator();

    });

  });
  // Expandable menu items

  const expandableItems = document.querySelectorAll('.twisted-drawer__parent');

  expandableItems.forEach(item => {

    item.addEventListener('click', () => {

      const parent = item.closest('.twisted-drawer__item');

      parent.classList.toggle('open');

    });

  });


  // Sliding tab indicator

  function moveDrawerIndicator() {

    const active =
      drawer.querySelector('.twisted-drawer__tab.active');

    const indicator =
      drawer.querySelector('.twisted-drawer__tab-indicator');


    if (!active || !indicator) return;


    indicator.style.left = active.offsetLeft + 'px';

    indicator.style.width = active.offsetWidth + 'px';

  }


});